import { useMemo, useState, useCallback } from "react";
import { servicesPartnersGroupId, ColorBy, UIView } from "@atlas-int/data";

export interface UseHiddenCategoriesReturn {
  hiddenCategories: string[];
  setHiddenCategories: (categories: string[]) => void;
}

export interface UseHiddenCategoriesOptions {
  defaultHidden?: string[];
}

/**
 * Atlas-specific wrapper around the generic useHiddenCategories hook.
 * Applies domain rules:
 * - Markets view: services partners hidden by default
 * - Complexity coloring: all shown
 * - Products view: services partners removed from hidden list
 */
export const useHiddenCategories = (
  view?: UIView,
  colorBy?: ColorBy,
): UseHiddenCategoriesReturn => {
  const defaultHidden = useMemo(() => {
    if (colorBy === ColorBy.Complexity) return [];
    if (view === UIView.Markets) return [servicesPartnersGroupId];
    return [];
  }, [colorBy, view]);

  const [hiddenCategories, setHiddenCategories] = useState<string[]>(defaultHidden);
  return { hiddenCategories, setHiddenCategories };
};
